import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";

// Pages
import Layout from "./Components/Layout/Layout.jsx";
import MTCLandingPage from "./Components/home.jsx"; // عدّل المسار حسب مكان الملف عندك

import "@fontsource/almarai";

const router = createBrowserRouter([
       {
         path: "/",
         element: <Layout />,
         children: [
           { index: true, element: <MTCLandingPage /> },
         ],
       },
     ]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;